import {
  CardContainerText,
  Title,
  WrapperContent,
  Subtitle,
  Info,
  LabelWrapper,
  Label,
  Time,
  Url,
} from "./styles";
import SimpleRichText from "@/components/SimpleRichText";
import { useTranslation } from "@/lib/translations";
import { useRouter } from "next/router";

export type TextProps = {
  variant: "text";
  title?: string;
  datetime?: string;
  content: any | null;
  externalLink?: {
    title?: string;
    url?: string;
    blank: boolean;
  };
};

const Text: React.FC<TextProps> = (props) => {
  const { title, datetime, externalLink, content } = props;
  const { locale = "it" } = useRouter();
  const t = {
    hour: useTranslation("investor.time", locale) || "",
  };

  // TODO: how does it work with timezones?
  const getTime = (str: string) => {
    if (!str) return "";
    const time = new Date(str).toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
    return time;
  };

  const getDate = (str: string) => {
    if (!str) return "";
    const date = new Date(str).toLocaleString(locale, {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
    return date;
  };

  return (
    <CardContainerText>
      {datetime && <Title>{getDate(datetime)}</Title>}
      {title && <Subtitle>{title}</Subtitle>}
      <Info>
        {datetime && (
          <LabelWrapper>
            <Label>{t.hour}:</Label>
            <Time>{getTime(datetime)}</Time>
          </LabelWrapper>
        )}
        {externalLink && externalLink?.url && (
          <LabelWrapper>
            <Label>Link conference:</Label>
            <Url href={externalLink?.url} target={`${externalLink.blank ? "_blank" : ""}`}>
              {externalLink?.url}
            </Url>
          </LabelWrapper>
        )}
        {content && (
          <WrapperContent>
            <SimpleRichText body={content} />
          </WrapperContent>
        )}
      </Info>
    </CardContainerText>
  );
};

export default Text;
